export const localeRoot = "settings.community_bot.agents.landing_page";
